import { Autosize } from './autosize/autosize';
import { CommonModule } from '@angular/common';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { PipesModule } from '../pipes/pipes.module';
import { RankingComparisionComponent } from './ranking-comparision/ranking-comparision';
import { SellionsAdvantageComponent } from './sellions-advantage/sellions-advantage';
import { SellionsChartComponent } from './sellions-chart/sellions-chart';
import { SellionsCircleComponent } from './sellions-circle/sellions-circle';
import { SellionsEventComponent } from './sellions-event/sellions-event';
import { SellionsIconicMessageComponent } from './sellions-iconic-message/sellions-iconic-message';
import { SellionsIconPulsarComponent } from './sellions-icon-pulsar/sellions-icon-pulsar';
import { SellionsIndicatorBarComponent } from './sellions-indicator-bar/sellions-indicator-bar';
import { SellionsLegendComponent } from './sellions-legend/sellions-legend';
import { SellionsLoadingComponent } from './sellions-loading/sellions-loading';
import { SellionsPercentBlockComponent } from './sellions-percent-block/sellions-percent-block';
import { SellionsSecuredBgComponent } from './sellions-secured-bg/sellions-secured-bg';
import { SellionsSecuredFileComponent } from './sellions-secured-file/sellions-secured-file';
import { SellionsSecuredImgComponent } from './sellions-secured-img/sellions-secured-img';
import { SellionsSpinnerComponent } from './sellions-spinner/sellions-spinner';
import { SellionsTakePhoto } from './sellions-take-photo/sellions-take-photo';
import { SellionsTipComponent } from './sellions-tip/sellions-tip';

@NgModule({
  declarations: [
    SellionsLoadingComponent,
    SellionsLegendComponent,
    SellionsAdvantageComponent,
    SellionsTipComponent,
    RankingComparisionComponent,
    SellionsChartComponent,
    SellionsIndicatorBarComponent,
    SellionsLoadingComponent,
    SellionsSpinnerComponent,
    SellionsEventComponent,
    SellionsCircleComponent,
    SellionsIconPulsarComponent,
    SellionsIconicMessageComponent,
    SellionsPercentBlockComponent,
    SellionsSecuredBgComponent,
    SellionsSecuredImgComponent,
    SellionsSecuredFileComponent,
    Autosize,
    SellionsTakePhoto,
  ],
  imports: [PipesModule, IonicPageModule, CommonModule],
  exports: [
    SellionsLoadingComponent,
    SellionsLegendComponent,
    SellionsAdvantageComponent,
    SellionsTipComponent,
    RankingComparisionComponent,
    SellionsChartComponent,
    SellionsIndicatorBarComponent,
    SellionsLoadingComponent,
    SellionsSpinnerComponent,
    SellionsEventComponent,
    SellionsCircleComponent,
    SellionsIconPulsarComponent,
    SellionsIconicMessageComponent,
    SellionsPercentBlockComponent,
    SellionsSecuredBgComponent,
    SellionsSecuredImgComponent,
    SellionsSecuredFileComponent,
    Autosize,
    SellionsTakePhoto,
  ],
  entryComponents: [SellionsEventComponent],
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/shared/components/components.module.ts